// gridConfigs.js

export const gridConfigs = {
    REMITO: {
        entityName: 'remitosBOT',
        columns: [
            { field: "idReporte", headerName: "Id Reporte", width: 100 },
            { field: "tipo_Documento", headerName: "T. Documento", width: 110 },
            { field: "numero_Remito", headerName: "N° Remito", width: 130 },
            { field: "cantRemitos", headerName: "Cant. Remitos", width: 110 },
            { field: "oficina_Venta", headerName: "Oficina Venta", width: 100 },
            { field: "cUIT_Cliente", headerName: "CUIT Cliente", width: 110 },
            { field: "empresa", headerName: "Empresa", width: 100 },
            { field: "egreso_ID", headerName: "Egreso Id", width: 100 },
            { field: "origen", headerName: "Origen", width: 120 },
            { field: "docuemento", headerName: "Documento", width: 170 },
            { field: "estado", headerName: "Estado", width: 140 },
            { field: "fechaAlta", headerName: "Fecha Alta", width: 100, type: 'date' },
            { field: "nH", headerName: "N.H.", width: 40 },
            { field: "fechaNH", headerName: "Fecha N.H.", width: 130, type: 'date' },
            { field: "trackingRecepcion", headerName: "Tracking Recepción", width: 140 },
            { field: "trackingEnvio", headerName: "Tracking Envío", width: 140 },
            { field: "fechatracking", headerName: "Fecha Tracking", width: 140, type: 'date' },
            { field: "accion", headerName: "Acción", width: 90 },
        ],
    },
    AUTORIZACION: {
        entityName: 'autorizacionesBOT',
        columns: [
            { field: "idReporte", headerName: "Id Reporte", width: 100 },
            { field: "delegacion", headerName: "Delegación", width: 120 },
            { field: "tipoCorreo", headerName: "Tipo Correo", width: 120 },
            { field: "mailOrigen", headerName: "Mail Origen", width: 170 },
            { field: "eV", headerName: "E.V.", width: 100 },
            { field: "paciente", headerName: "Paciente", width: 180 },
            { field: "hC", headerName: "H.C.", width: 100 },
            { field: "asunto", headerName: "Asunto", width: 170 },
            { field: "adjunto", headerName: "Adjunto", width: 70 },
            { field: "estado", headerName: "Estado", width: 150 },
            { field: "fechaAlta", headerName: "Fecha Alta", width: 120, type: 'date' },
        ],
    },
    DEFAULT: {
        entityName: 'conformidadesBOT',
        columns: [
            { field: "idFormRef", headerName: "ID Formulario Referencia", width: 150 },
            { field: "referencia", headerName: "Referencia", width: 100 },
            { field: "numero", headerName: "Número", width: 100 },
            { field: "hc", headerName: "H.C.", width: 80 },
            { field: "paciente", headerName: "Paciente", width: 180 },
            { field: "contrato", headerName: "Contrato", width: 90 },
            { field: "mes", headerName: "Mes", width: 55 },
            { field: "cliente", headerName: "Cliente", width: 120 },
            { field: "origen", headerName: "Origen", width: 120 },
            { field: "documento", headerName: "Documento", width: 170 },
            { field: "estado", headerName: "Estado", width: 80 },
            { field: "fechaalta", headerName: "Fecha Alta", width: 100, type: 'date' },
        ],
    },
};